import classes from './card-brand.module.scss';

export const displayCardBrandImage = (brand?: string) => {
	if (!brand) {
		return (
			<>
				<img className={classes.brandImage} src="images/VISA.svg" alt="VISA" width="55" height="35" />
				<img className={classes.brandImage} src="images/mastercard.svg" alt="master card" width="55" height="35" />
				<img className={classes.brandImage} src="images/JCB.svg" alt="JCB" width="55" height="35" />
				<img className={classes.brandImage} src="images/amex.svg" alt="American Express" width="55" height="35" />
				<img
					className={classes.brandImageDiners}
					src="images/diners_logo_white.gif"
					alt="Diners Club"
					width="44"
					height="28"
				/>
			</>
		);
	}
	if (brand === 'VISA') {
		return <img className={classes.brandImage} src="images/VISA.svg" alt="VISA" width="55" height="35" />;
	}
	if (brand === 'MASTERCARD') {
		return <img className={classes.brandImage} src="images/mastercard.svg" alt="master card" width="55" height="35" />;
	}
	if (brand === 'JCB') {
		return <img className={classes.brandImage} src="images/JCB.svg" alt="JCB" width="55" height="35" />;
	}
	if (brand === 'AMEX') {
		return <img className={classes.brandImage} src="images/amex.svg" alt="American Express" width="55" height="35" />;
	}
	if (brand === 'DINERS') {
		return (
			<img className={classes.brandImage} src="images/diners_logo_white.gif" alt="Diners Club" width="55" height="35" />
		);
	}
	return null;
};
